import React from 'react'
import PropTypes from 'prop-types'
import { Label, FormFeedback, FormGroup } from 'reactstrap'
import _ from 'lodash'
import { Field } from 'formik'
import Tooltip from './Tooltip'

export default class FormikInputField extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    dataTestId: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    data: PropTypes.array,
    renderOptions: PropTypes.func,
    tooltip: PropTypes.string,
  }
  static defaultProps = {}

  render() {
    const props = this.props
    const error = _.get(props.errors, props.name)
    const isInvalid = error && _.get(props.touched, props.name)
    return (
      <FormGroup>
        <Label>{props.label || props.children}</Label>
        <Tooltip title={props.tooltip || null}>
          <Field
            className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
            component="select"
            disabled={props.disabled || props.isSubmitting}
            id={props.id}
            data-testid={props.dataTestId}
            name={props.name}
            valid={isInvalid ? 'false' : 'true'}
          >
            <option />
            {props.data &&
              props.data.map(
                props.renderOptions
                  ? props.renderOptions
                  : val => <option key={val}>{val}</option>,
              )}
          </Field>
          <FormFeedback>{error}</FormFeedback>
        </Tooltip>
      </FormGroup>
    )
  }
}
